import { Helmet } from 'react-helmet-async';

export const WebsiteSchema = () => {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "UGC Video Oluşturucu",
    "alternateName": "UGC Studio",
    "url": "https://ugcvideoolusturucu.com.tr",
    "description": "Türkiye'nin en etkili UGC video ajansı. E-ticaret satışlarınızı artıran, sosyal medyada viral olan kullanıcı içerikli videolar üretiyoruz.",
    "inLanguage": "tr",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://ugcvideoolusturucu.com.tr/?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@type": "Organization",
      "name": "UGC Video Oluşturucu",
      "logo": {
        "@type": "ImageObject",
        "url": "https://ugcvideoolusturucu.com.tr/logo.png"
      }
    }
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://ugcvideoolusturucu.com.tr/#localbusiness",
    "name": "UGC Video Oluşturucu",
    "alternateName": "UGC Studio Türkiye",
    "description": "Türkiye'nin lider UGC video ajansı. Instagram Reels, TikTok reklamları ve e-ticaret ürün tanıtım videoları üretiyoruz. Profesyonel UGC içerik üretimi ile markanızın satışlarını artırın.",
    "url": "https://ugcvideoolusturucu.com.tr",
    "telephone": "+90-212-XXX-XXXX",
    "email": "info@ugcvideoolusturucu.com.tr",
    "image": [
      "https://ugcvideoolusturucu.com.tr/logo.png",
      "https://ugcvideoolusturucu.com.tr/og-image.jpg"
    ],
    "logo": {
      "@type": "ImageObject",
      "url": "https://ugcvideoolusturucu.com.tr/logo.png",
      "width": 512,
      "height": 512
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Levent Mahallesi, Büyükdere Caddesi",
      "addressLocality": "İstanbul",
      "addressRegion": "Beşiktaş",
      "postalCode": "34394",
      "addressCountry": "TR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 41.0785,
      "longitude": 29.0108
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],
    "priceRange": "₺₺",
    "currenciesAccepted": "TRY",
    "paymentAccepted": "Kredi Kartı, Banka Havalesi",
    "areaServed": [
      {
        "@type": "Country",
        "name": "Türkiye"
      },
      {
        "@type": "City",
        "name": "İstanbul"
      },
      {
        "@type": "City",
        "name": "Ankara"
      },
      {
        "@type": "City",
        "name": "İzmir"
      }
    ],
    "serviceType": [
      "UGC Video Oluşturucu",
      "UGC Video Ücretsiz",
      "UGC Video Oluşturucu Ücretsiz",
      "UGC Video Örnekleri",
      "UGC Video İndirme",
      "UGC Video Uygulaması",
      "UGC Video Reklamları",
      "UGC Video AI Oluşturucu",
      "Instagram Reels İçerik Üretimi",
      "TikTok Reklam Videoları",
      "E-ticaret Ürün Tanıtım Videoları",
      "Sosyal Medya Video İçerik Üretimi"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "UGC Video Hizmetleri",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "UGC Video Üretimi",
            "description": "Profesyonel UGC içerik üretimi ile markanızın sosyal medya etkileşimini artırın"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Instagram Reels Prodüksiyon",
            "description": "Viral Instagram Reels içerikleri ile organik erişiminizi katlayın"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "TikTok Reklam Videoları",
            "description": "TikTok platformuna özel yüksek dönüşümlü reklam videoları"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "E-ticaret Ürün Videoları",
            "description": "Satışlarınızı artıran profesyonel ürün tanıtım videoları"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Ahmet Y."
        },
        "datePublished": "2024-12-15",
        "reviewBody": "E-ticaret sitemiz için hazırladıkları UGC videolar sayesinde satışlarımız %40 arttı. Kesinlikle tavsiye ederim!",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Zeynep K."
        },
        "datePublished": "2024-11-28",
        "reviewBody": "Instagram Reels içerikleri gerçekten viral oldu. Marka bilinirliğimiz inanılmaz arttı.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      }
    ],
    "sameAs": [
      "https://www.instagram.com/ugcvideoolusturucu",
      "https://www.tiktok.com/@ugcvideoolusturucu",
      "https://www.linkedin.com/company/ugcvideoolusturucu",
      "https://twitter.com/ugcvideo_tr"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
    </Helmet>
  );
};
